module.exports = __webpack_public_path__ + "static/media/ProductSearch_004.6f59f3e3.png";